import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query Users($search: String, $active: Boolean, $hasRole: Boolean, $page: Int, $perPage: Int) {
    Users(search: $search, active: $active, hasRole: $hasRole, page: $page, perPage: $perPage) {
      items {
        active
        id
        role {
          name
        }
        email
        userName
        firstName
        lastName
      }
      paginationInfo {
        hasMore
        page
        perPage
        totalData
        totalPages
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  active: string;
  id: string;
  role: {
    name: string;
  };
  email: string;
  userName: string;
  firstName: string;
  lastName: string;
}

export interface GetAllGql {
  Users: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}

export interface GetAllVariables {
  search?: string | null;
  active?: boolean | null;
  hasRole?: boolean | null;
  page?: number;
  perPage?: number;
}
